import { tableIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Spreadsheet = createIcon({
  displayName: 'Spreadsheet',
  paths: [
    'M682.667 768v-85.333h170.667v85.333h-170.667zM426.667 768h170.667v-85.333h-170.667v85.333zM170.667 768h170.667v-85.333h-170.667v85.333zM682.667 597.333h170.667v-85.333h-170.667v85.333zM426.667 597.333h170.667v-85.333h-170.667v85.333zM170.667 597.333h170.667v-85.333h-170.667v85.333zM682.667 426.667h170.667v-85.333h-170.667v85.333zM426.667 426.667h170.667v-85.333h-170.667v85.333zM170.667 426.667h170.667v-85.333h-170.667v85.333zM853.333 170.667c47.104 0 85.333 38.229 85.333 85.333v512c0 47.104-38.229 85.333-85.333 85.333h-682.667c-47.104 0-85.333-38.229-85.333-85.333v-512c0-47.104 38.229-85.333 85.333-85.333h682.667z'
  ],
  canvasPaths: canvasIconPaths(tableIcon)
})
